export function init($name) {
    if (!$($name).length) {
        return;
    }

    let slider = $name + ' .slider';
    let titles = $name + ' .titles';
    let length = $(slider).find('li').length;

    if ($(slider).length && $(titles).length) {

        $(slider).on('init', function (e, slick) {
            const sliderRow = $(slick.$slider[0]).find('.slick-track');
            const overlay = $('.slider-overlay');

            setTimeout(function () {
                $(slider).addClass('js-ready-to-animate');
                $(titles).addClass('js-ready-to-animate');
                let actualSlide = slick.$slides[slick.currentSlide];
                $(actualSlide).addClass('js-slick-beforedraw');
                $(overlay).removeClass('js-slick-overlay--index');


                setTimeout(function () {
                    $(overlay).addClass('js-slick-overlay--index');
                    $(actualSlide).addClass('js-slick-draw');
                }, 750);
            }, 0);

            $(sliderRow).on('mousedown', function (e) {
                let actualSlide = slick.$slides[slick.currentSlide];

                $(this).one('mouseup', function (e) {

                    $(this).off('mousemove');

                }).on('mousemove', function (e) {
                    setTimeout(function () {
                        $(overlay).removeClass('js-slick-overlay--index');
                        $(actualSlide).removeClass('js-slick-beforedraw');
                        $(actualSlide).removeClass('js-slick-draw');
                    }, 100);
                });
            });

            $(sliderRow).on('touchstart', function (e) {
                let actualSlide = slick.$slides[slick.currentSlide];

                $(this).one('touchend', function (e) {

                    $(this).off('touchmove');

                }).on('touchmove', function (e) {
                    setTimeout(function () {
                        $(overlay).removeClass('js-slick-overlay--index');
                        $(actualSlide).removeClass('js-slick-beforedraw');
                        $(actualSlide).removeClass('js-slick-draw');
                    }, 100);
                });
            });
        });

        $(slider).slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: false,
            variableWidth: true,
            centerMode: true,
            swipe: true,
            swipeToSlide: true,
            focusOnSelect: true,
            asNavFor: titles,
            slidesToShow: 6,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $(titles).slick({
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: false,
            variableWidth: false,
            centerMode: true,
            swipe: true,
            swipeToSlide: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            prevArrow: '<button type="button" name="Previouse" title="Previouse" value="Previouse" class="slick-prev"><i class="icon icon-arrow_left"></i></button>',
            nextArrow: '<button type="button" name="Next" title="Next" value="Next" class="slick-next"><i class="icon icon-arrow_right"></i></button>',
            asNavFor: slider
        });

        const overlay = $('.slider-overlay');

        $(slider)[0].slick.slickGoTo(Math.floor(length / 2));

        $(slider).on('swipe', function () {
            $(overlay).removeClass('js-slick-overlay--index');
        });

        $(slider).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            let actualSlide = slick.$slides[currentSlide];

            setTimeout(function () {
                $(overlay).removeClass('js-slick-overlay--index');
                $(actualSlide).removeClass('js-slick-beforedraw');
                $(actualSlide).removeClass('js-slick-draw');
            }, 100);
        });

        $(slider).on('afterChange', function (event, slick, currentSlide) {
            if (!$('.section-why-ox').hasClass('js-show-slides-done')) {
                return;
            }
            let actualSlide = slick.$slides[currentSlide];
            $(actualSlide).addClass('js-slick-beforedraw');
            setTimeout(function () {

                if ($(overlay).hasClass('js-slick-overlay--fullpage')) {
                    setTimeout(function () {

                        $(overlay).addClass('js-slick-overlay--index');
                        $(actualSlide).addClass('js-slick-draw');
                    }, 750);
                } else {
                    $(overlay).addClass('js-slick-overlay--index');
                    $(actualSlide).addClass('js-slick-draw');
                }
            }, 50);
        });

        let elFrame = $('#frame-zoom-check')[0];
        let previouseTrigger = false;

        if (elFrame.contentWindow) {
            $(elFrame.contentWindow).resize(function() {
                if (!previouseTrigger && $(slider).hasClass('slick-initialized')) {
                    previouseTrigger = true;
                    $(window).trigger('zoom');
                }
            });

            $(window).on('zoom', function() {
                setTimeout(function() {
                    $(slider).slick('slickNext');
                    previouseTrigger = false;
                }, 500);
            });
        }
    }
}
